import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 33566CF8-43DC-48FF-9891-557946141997
 * name view-grid-outline
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-grid-outline.svg
 * tags
 * - View 
 */
export const ViewGridOutlineIcon = createSvgIcon(<><path d="M3 11H11V3H3M5 5H9V9H5M13 21H21V13H13M15 15H19V19H15M3 21H11V13H3M5 15H9V19H5M13 3V11H21V3M19 9H15V5H19Z" /></>, 'ViewGridOutlineIcon');
export default ViewGridOutlineIcon